import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
  providedIn: 'root',
})
export class EventEmitterService {
  invokeClickSave = new EventEmitter();
  savedData = new BehaviorSubject('');
  public savedData$ = this.savedData.asObservable();
  subsVar: Subscription;

  constructor() {}

  clickSave(name) {
    this.invokeClickSave.emit(name);
  }
  dataSaved(data){
    console.log(data);
    
    this.savedData.next(data)
  }
}
